// @flow
import styled from 'styled-components';

export const WhiteWrap = styled.div`
  background: #fff;
`;
export const GrayWrap = styled.div`
  background: #f8f9fa;
`;
